// Shared regex and helpers for client-side form validation (LDCP-185).

export const IPV4_REGEX =
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
export const IPV6_REGEX =
  /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^::(?:[0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4}$|^(?:[0-9a-fA-F]{1,4}:){1,7}:$|^(?:[0-9a-fA-F]{1,4}:){0,6}::(?:[0-9a-fA-F]{1,4}:){0,5}[0-9a-fA-F]{1,4}$/;
export const CIDR_V4_REGEX =
  /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(?:[0-9]|[1-2][0-9]|3[0-2])$/;
export const CIDR_V6_REGEX =
  /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}\/(?:[0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8])$|^::(?:[0-9a-fA-F]{1,4}:){0,6}[0-9a-fA-F]{1,4}\/(?:[0-9]|[1-9][0-9]|1[0-1][0-9]|12[0-8])$/;

export const URL_REGEX = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const JA3_REGEX = /^[0-9a-fA-F]{32}$/;
export const JA4_REGEX = /^[A-Za-z0-9_]{1,64}$/;
export const UID_REGEX = /^[\x21-\x7E]{1,128}$/;
export const PATH_GLOB_REGEX = /^\/[^\s]{0,511}$/;
export const HOSTNAME_GLOB_REGEX =
  /^(\*\*|\*|[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)(\.(\*\*|\*|[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?))*$/;
export const CITY_REGEX = /^[\p{L}\p{M}\s'.-]{1,128}$/u;
export const HEADER_NAME_REGEX = /^[!#$&'*+.^_`|~0-9A-Za-z-]{1,128}$/;

export const PORT_MIN = 1;
export const PORT_MAX = 65535;
export const ASN_MAX = 4294967295;

export function isValidIp(ip) {
  return IPV4_REGEX.test(ip) || IPV6_REGEX.test(ip);
}

export function isValidCidr(cidr) {
  return CIDR_V4_REGEX.test(cidr) || CIDR_V6_REGEX.test(cidr);
}

export function isValidIpRange(range) {
  const parts = range.split("-");
  if (parts.length !== 2) return false;
  return isValidIp(parts[0].trim()) && isValidIp(parts[1].trim());
}

export function isValidIpOrCidrOrRange(value) {
  const v = String(value || "").trim();
  if (!v) return false;
  return isValidIp(v) || isValidCidr(v) || isValidIpRange(v);
}

export function parseJsonSafe(raw) {
  if (raw === undefined || raw === null || raw === "") return { ok: true, value: null };
  try {
    return { ok: true, value: JSON.parse(raw) };
  } catch (e) {
    return { ok: false, message: e.message || "Invalid JSON" };
  }
}

export function isValidPort(value) {
  const n = Number(value);
  return Number.isInteger(n) && n >= PORT_MIN && n <= PORT_MAX;
}

export function isValidAsn(value) {
  const n = typeof value === "number" ? value : parseInt(String(value).trim(), 10);
  return Number.isInteger(n) && n >= 0 && n <= ASN_MAX;
}

export function isValidBotScore(value) {
  const n = typeof value === "number" ? value : parseInt(String(value).trim(), 10);
  return Number.isInteger(n) && n >= 0 && n <= 100;
}

/** @returns {{ valid: boolean, message?: string }} */
export function validationResult(valid, message) {
  return valid ? { valid: true } : { valid: false, message };
}
